import moment from 'moment';

class MembershipBannerController {

    constructor(basket, loginoutService) {
        this.basket = basket;
        this.loginoutService = loginoutService;
    }

    $onInit () {
        this.basket.promise && this.basket.promise.then(() => {
            this.setDiscount();
        });
    }

    showDiscount () {
        this.setDiscount();

        if (!this.details
            || (this.event && !this.event.date)
            || !this.loginoutService.isLoggedIn()) {
            return false;
        }

        if (this.details && !this.event) {
            return true;
        }

        let dayOfWeek = moment(this.event.date).day();

        return this.discounts[dayOfWeek] > 0 && this.matchedEventType();
    }

    matchedEventType () {
        return (this.event.type === 'Treatment' && this.details.treatments) ||
            (this.event.type === 'Spa Day' && this.details.spa_days);
    }

    setDiscount () {
        if (this.details) {
            return false;
        }

        this.details = this.basket.contents.membership_discount;

        if (this.details) {
            this.discounts = [
                this.details.sun_discount,
                this.details.mon_discount,
                this.details.tue_discount,
                this.details.wed_discount,
                this.details.thu_discount,
                this.details.fri_discount,
                this.details.sat_discount,
            ];
        }
    }
}

MembershipBannerController.$inject = ['basket', 'loginoutService'];

export default MembershipBannerController;



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/basket/controllers/membershipBanner.controller.js